//
//
//
//
//
//
export default {
  name: 'Stars',
  props: ['value', 'disabled'],
  data: function data() {
    return {
      tempValue: null,
      ratings: [1, 2, 3, 4, 5],
      onMouseOver: false
    };
  },
  methods: {
    star_over: function star_over(rate) {
      if (!this.disabled) {
        this.tempValue = rate;
        this.onMouseOver = true;
      }
    },
    star_out: function star_out() {
      this.onMouseOver = false;
    },
    set: function set(value) {
      if (!this.disabled) {
        this.tempValue = value;
        this.$emit('input', this.tempValue);
      }
    }
  }
};